document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('overview-search');
    if (!form) return;

    const dropdown = form.querySelector('.dropdown');
    const triggerButton = dropdown.querySelector('.dropdown-trigger button');
    const dropdownItems = dropdown.querySelectorAll('.dropdown-item');
    const input = form.querySelector('input[type="search"]');
    const displayValueSpan = triggerButton.querySelector('.dropdown-trigger__label');

    triggerButton.addEventListener('click', function (e) {
        e.stopPropagation();
        const isActive = dropdown.classList.toggle('is-active');
        triggerButton.setAttribute('aria-expanded', isActive.toString());
    });

    dropdownItems.forEach(item => {
        item.addEventListener('click', function (e) {
            e.preventDefault();

            const action = item.getAttribute('data-action');
            const param = item.getAttribute('data-param');
            const label = item.textContent.trim();

            if (action) form.setAttribute('action', action);
            if (param) input.setAttribute('name', param);
            if (label) displayValueSpan.textContent = label;

            dropdownItems.forEach(i => {
                i.classList.remove('is-active');
                i.setAttribute('aria-selected', 'false');
            });

            item.classList.add('is-active');
            item.setAttribute('aria-selected', 'true');

            dropdown.classList.remove('is-active');
            triggerButton.setAttribute('aria-expanded', 'false');
        });
    });

    document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target)) {
            dropdown.classList.remove('is-active');
            triggerButton.setAttribute('aria-expanded', 'false');
        }
    });
});
